
import React from 'react'
import { Link } from 'react-router-dom'
import '../scss/EventoList.css'
import Logo from '../icons/logo.svg'
import moment from 'moment'

const displayTime = (t) => {
  if (t) {
    let list = t.split(':')
    return parseInt(list[0], 10) + ':' + list[1] + 'h'
  }
  return null
}

const EventoList = (props) => (
  <div className={'container--padding'}>
    <div className={'logo'}><img src={Logo} alt={'Logo ChampionChipNorte Live'} /></div>
    <ul className={'evento-list'}>
      {props.eventos.map(evento => (
        <li key={evento.id} className={'evento-list__item'}>
          <Link to={`/${evento.id}`}>
            <div className={'evento-list__item__name'}>
              {evento.nombre}
            </div>
            <div className={'evento-list__item__estado'}>
              <div className={'etiqueta'}>INICIO:</div>
              <span className={'fecha'}>{moment(evento.fecha_inicio).format('DD/MM/YYYY')}</span> &nbsp;
              <span className={'hora'}>{displayTime(evento.hora_inicio)}</span>
            </div>
          </Link>
        </li>
      ))}
    </ul>
  </div>
)

export default EventoList



// WEBPACK FOOTER //
// ./src/components/EventoList.js